import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";
import { AssetItemDocumentIcon } from "@/icons/primary";

type Props = {
  type?: "document";
  size: string;
  name: string;
  onClick?: () => void;
};

const bem = new BemHelper("assets-item");

export const AssetsItem: React.FC<Props> = ({ type = "document", name, onClick, size }) => {
  return (
    <div
      className={classNames(bem.block())}
      onClick={() => {
        if (typeof onClick === "function") onClick();
      }}
    >
      <div className={classNames(bem.element("size"))}>{size}</div>
      <div className={classNames(bem.element("image"))}>
        {type == "document" && <AssetItemDocumentIcon />}
      </div>
      <div className={classNames(bem.element("name"))}>{name}</div>
      {/*
      {!invisibleTitle && <div className={classNames(bem.element("link"))}>{data.title}</div>} */}
    </div>
  );
};
